<template>
    <div v-if="isPayed('G01') || isSAAdmin" class="detail-card">
        <div class="card-header">
            <div class="title">會計</div>
        </div>
        <div class="card-body">
            <spec-view>
                <spec-item label="會計傳票">
                    <span :class="{ clickable: isAuth('G01') }" @click="onOpenAccountingDetail">{{ qty }}張</span>
                </spec-item>
                <spec-item v-if="queryType === 1 || queryType === 2" label="立帳科目">
                    <span v-if="accno && accnam">{{ accno }} - {{ accnam }}</span>
                    <span v-else>---</span>
                </spec-item>
                <spec-item v-if="queryType === 1 || queryType === 2" label="沖帳科目">
                    <span v-if="clearanceAccno && clearanceAccnoNam">{{ clearanceAccno }} - {{ clearanceAccnoNam }}</span>
                    <span v-else>---</span>
                </spec-item>
                <spec-item label="財會檢核">
                    <span :class="`color-${status}`">{{ statusTxt }}</span>
                </spec-item>
                <spec-item label="檢核人">
                    {{ voucherStatusUpdater || "---" }}
                    <span v-if="voucherStatusUpdateDate">（{{ voucherStatusUpdateDate | dateFormater("YYYY-MM-dd") }}）</span>
                </spec-item>
            </spec-view>
        </div>
        <AccountingDetailDialog :visible="accountingDetailDialog.visible" :QueryType="queryType" :sno="accountingDetailDialog.sno" @close="onAccountingDetailDialogClose"></AccountingDetailDialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import AccountingDetailDialog from '@/components/dashboard/Accounting/AccountingSummary/AccountingDetailDialog.vue';

export default {
    props: {
        sno: [Number, Object],
        qty: Number,
        status: Number,
        queryType: Number,
        voucherStatusUpdater: String,
        voucherStatusUpdateDate: Number,

        accno: String,
        accnam: String,
        clearanceAccno: String,
        clearanceAccnoNam: String,
    },
    components: { SpecView, SpecItem, AccountingDetailDialog },
    data() {
        return {
            accountingDetailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    computed: {
        ...mapGetters({ isSAAdmin: 'account/isSAAdmin' }),
        statusTxt() {
            switch (this.status) {
            case 1:
                return '完成';
            case 2:
                return '不作帳';
            default:
                return '待辦';
            }
        },
    },
    methods: {
        onOpenAccountingDetail() {
            if (!this.isAuth('G01')) return;

            this.accountingDetailDialog.sno = this.sno;
            this.accountingDetailDialog.visible = true;
        },
        onAccountingDetailDialogClose(refresh) {
            this.accountingDetailDialog.visible = false;
            this.accountingDetailDialog.sno = null;
            if (refresh) this.$emit('refresh');
        },
    },
};
</script>

<style lang="scss" scoped>
.clickable {
    cursor: pointer;
    color: #463cb2;
    font-weight: bold;
}
.color-0 {
    color: #ef6401;
}
.color-1 {
    color: #0baa1b;
}
.color-2 {
    color: #aaa;
}
</style>
